export default "__VITE_ASSET__00dd3116__"